export default __webpack_public_path__ + "static/media/goopter-disinfection-robot-sensors.da83743b.png";